import React from "react";
import Main from "../../components/forms/main";
import SEO from "../../components/meta-tags";
const Forms = () => {
  return (
    <>
      <SEO title={"Forms"} />
      <Main />
    </>
  );
};

export default Forms;
